// extracted by mini-css-extract-plugin
export default {"root":"DragMove-module-root-dJnxC","fullSize":"DragMove-module-fullSize-iqMjB","draggingEnabled":"DragMove-module-draggingEnabled-zRViz"};